import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    accordions: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        paddingX: theme.spacing(0),
        borderRadius: '4px',
    },
    scrollBox: {
        height: `100%`,
        display: 'flex',
        padding: theme.spacing(3),
        flexDirection: 'column',
        overflowY: 'auto',
    },
}));

export default useStyles;
